import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, ChevronDown, LockKeyhole, Mail, ShieldCheck, UserPlus } from "lucide-react";
import { API_BASE_URL as API } from "../../apiConfig";

const retailTokenKey = "retail_member_token";
const travelAgencyTokenKey = "token";
const travelAgencyUserKey = "user";

const memberEmailLanguageOptions = [
  { value: "en", label: "English" },
  { value: "ja", label: "日本語" },
  { value: "zh", label: "简体中文" },
  { value: "zhHant", label: "繁體中文" },
];

function normalizeMemberEmailLanguage(value) {
  return memberEmailLanguageOptions.some((option) => option.value === value) ? value : "en";
}

export const phoneCountryOptions = [
  { value: "JP", dialCode: "+81", label: "Japan +81" },
  { value: "CN", dialCode: "+86", label: "China +86" },
  { value: "TW", dialCode: "+886", label: "Taiwan +886" },
  { value: "HK", dialCode: "+852", label: "Hong Kong +852" },
  { value: "US", dialCode: "+1", label: "United States +1" },
  { value: "CA", dialCode: "+1", label: "Canada +1" },
  { value: "AF", dialCode: "+93", label: "Afghanistan +93" },
  { value: "AX", dialCode: "+358", label: "Aland Islands +358" },
  { value: "AL", dialCode: "+355", label: "Albania +355" },
  { value: "DZ", dialCode: "+213", label: "Algeria +213" },
  { value: "AS", dialCode: "+1", label: "American Samoa +1" },
  { value: "AD", dialCode: "+376", label: "Andorra +376" },
  { value: "AO", dialCode: "+244", label: "Angola +244" },
  { value: "AI", dialCode: "+1", label: "Anguilla +1" },
  { value: "AG", dialCode: "+1", label: "Antigua and Barbuda +1" },
  { value: "AR", dialCode: "+54", label: "Argentina +54" },
  { value: "AM", dialCode: "+374", label: "Armenia +374" },
  { value: "AW", dialCode: "+297", label: "Aruba +297" },
  { value: "AU", dialCode: "+61", label: "Australia +61" },
  { value: "AT", dialCode: "+43", label: "Austria +43" },
  { value: "AZ", dialCode: "+994", label: "Azerbaijan +994" },
  { value: "BS", dialCode: "+1", label: "Bahamas +1" },
  { value: "BH", dialCode: "+973", label: "Bahrain +973" },
  { value: "BD", dialCode: "+880", label: "Bangladesh +880" },
  { value: "BB", dialCode: "+1", label: "Barbados +1" },
  { value: "BY", dialCode: "+375", label: "Belarus +375" },
  { value: "BE", dialCode: "+32", label: "Belgium +32" },
  { value: "BZ", dialCode: "+501", label: "Belize +501" },
  { value: "BJ", dialCode: "+229", label: "Benin +229" },
  { value: "BM", dialCode: "+1", label: "Bermuda +1" },
  { value: "BT", dialCode: "+975", label: "Bhutan +975" },
  { value: "BO", dialCode: "+591", label: "Bolivia +591" },
  { value: "BQ", dialCode: "+599", label: "Bonaire, Sint Eustatius and Saba +599" },
  { value: "BA", dialCode: "+387", label: "Bosnia and Herzegovina +387" },
  { value: "BW", dialCode: "+267", label: "Botswana +267" },
  { value: "BR", dialCode: "+55", label: "Brazil +55" },
  { value: "IO", dialCode: "+246", label: "British Indian Ocean Territory +246" },
  { value: "BN", dialCode: "+673", label: "Brunei +673" },
  { value: "BG", dialCode: "+359", label: "Bulgaria +359" },
  { value: "BF", dialCode: "+226", label: "Burkina Faso +226" },
  { value: "BI", dialCode: "+257", label: "Burundi +257" },
  { value: "KH", dialCode: "+855", label: "Cambodia +855" },
  { value: "CM", dialCode: "+237", label: "Cameroon +237" },
  { value: "CV", dialCode: "+238", label: "Cape Verde +238" },
  { value: "KY", dialCode: "+1", label: "Cayman Islands +1" },
  { value: "CF", dialCode: "+236", label: "Central African Republic +236" },
  { value: "TD", dialCode: "+235", label: "Chad +235" },
  { value: "CL", dialCode: "+56", label: "Chile +56" },
  { value: "CX", dialCode: "+61", label: "Christmas Island +61" },
  { value: "CC", dialCode: "+61", label: "Cocos Islands +61" },
  { value: "CO", dialCode: "+57", label: "Colombia +57" },
  { value: "KM", dialCode: "+269", label: "Comoros +269" },
  { value: "CG", dialCode: "+242", label: "Congo +242" },
  { value: "CD", dialCode: "+243", label: "Congo DR +243" },
  { value: "CK", dialCode: "+682", label: "Cook Islands +682" },
  { value: "CR", dialCode: "+506", label: "Costa Rica +506" },
  { value: "CI", dialCode: "+225", label: "Cote d'Ivoire +225" },
  { value: "HR", dialCode: "+385", label: "Croatia +385" },
  { value: "CU", dialCode: "+53", label: "Cuba +53" },
  { value: "CW", dialCode: "+599", label: "Curacao +599" },
  { value: "CY", dialCode: "+357", label: "Cyprus +357" },
  { value: "CZ", dialCode: "+420", label: "Czechia +420" },
  { value: "DK", dialCode: "+45", label: "Denmark +45" },
  { value: "DJ", dialCode: "+253", label: "Djibouti +253" },
  { value: "DM", dialCode: "+1", label: "Dominica +1" },
  { value: "DO", dialCode: "+1", label: "Dominican Republic +1" },
  { value: "EC", dialCode: "+593", label: "Ecuador +593" },
  { value: "EG", dialCode: "+20", label: "Egypt +20" },
  { value: "SV", dialCode: "+503", label: "El Salvador +503" },
  { value: "GQ", dialCode: "+240", label: "Equatorial Guinea +240" },
  { value: "ER", dialCode: "+291", label: "Eritrea +291" },
  { value: "EE", dialCode: "+372", label: "Estonia +372" },
  { value: "SZ", dialCode: "+268", label: "Eswatini +268" },
  { value: "ET", dialCode: "+251", label: "Ethiopia +251" },
  { value: "FK", dialCode: "+500", label: "Falkland Islands +500" },
  { value: "FO", dialCode: "+298", label: "Faroe Islands +298" },
  { value: "FJ", dialCode: "+679", label: "Fiji +679" },
  { value: "FI", dialCode: "+358", label: "Finland +358" },
  { value: "FR", dialCode: "+33", label: "France +33" },
  { value: "GF", dialCode: "+594", label: "French Guiana +594" },
  { value: "PF", dialCode: "+689", label: "French Polynesia +689" },
  { value: "GA", dialCode: "+241", label: "Gabon +241" },
  { value: "GM", dialCode: "+220", label: "Gambia +220" },
  { value: "GE", dialCode: "+995", label: "Georgia +995" },
  { value: "DE", dialCode: "+49", label: "Germany +49" },
  { value: "GH", dialCode: "+233", label: "Ghana +233" },
  { value: "GI", dialCode: "+350", label: "Gibraltar +350" },
  { value: "GR", dialCode: "+30", label: "Greece +30" },
  { value: "GL", dialCode: "+299", label: "Greenland +299" },
  { value: "GD", dialCode: "+1", label: "Grenada +1" },
  { value: "GP", dialCode: "+590", label: "Guadeloupe +590" },
  { value: "GU", dialCode: "+1", label: "Guam +1" },
  { value: "GT", dialCode: "+502", label: "Guatemala +502" },
  { value: "GG", dialCode: "+44", label: "Guernsey +44" },
  { value: "GN", dialCode: "+224", label: "Guinea +224" },
  { value: "GW", dialCode: "+245", label: "Guinea-Bissau +245" },
  { value: "GY", dialCode: "+592", label: "Guyana +592" },
  { value: "HT", dialCode: "+509", label: "Haiti +509" },
  { value: "HN", dialCode: "+504", label: "Honduras +504" },
  { value: "HU", dialCode: "+36", label: "Hungary +36" },
  { value: "IS", dialCode: "+354", label: "Iceland +354" },
  { value: "IN", dialCode: "+91", label: "India +91" },
  { value: "ID", dialCode: "+62", label: "Indonesia +62" },
  { value: "IR", dialCode: "+98", label: "Iran +98" },
  { value: "IQ", dialCode: "+964", label: "Iraq +964" },
  { value: "IE", dialCode: "+353", label: "Ireland +353" },
  { value: "IM", dialCode: "+44", label: "Isle of Man +44" },
  { value: "IL", dialCode: "+972", label: "Israel +972" },
  { value: "IT", dialCode: "+39", label: "Italy +39" },
  { value: "JM", dialCode: "+1", label: "Jamaica +1" },
  { value: "JE", dialCode: "+44", label: "Jersey +44" },
  { value: "JO", dialCode: "+962", label: "Jordan +962" },
  { value: "KZ", dialCode: "+7", label: "Kazakhstan +7" },
  { value: "KE", dialCode: "+254", label: "Kenya +254" },
  { value: "KI", dialCode: "+686", label: "Kiribati +686" },
  { value: "XK", dialCode: "+383", label: "Kosovo +383" },
  { value: "KR", dialCode: "+82", label: "Korea +82" },
  { value: "KW", dialCode: "+965", label: "Kuwait +965" },
  { value: "KG", dialCode: "+996", label: "Kyrgyzstan +996" },
  { value: "LA", dialCode: "+856", label: "Laos +856" },
  { value: "LV", dialCode: "+371", label: "Latvia +371" },
  { value: "LB", dialCode: "+961", label: "Lebanon +961" },
  { value: "LS", dialCode: "+266", label: "Lesotho +266" },
  { value: "LR", dialCode: "+231", label: "Liberia +231" },
  { value: "LY", dialCode: "+218", label: "Libya +218" },
  { value: "LI", dialCode: "+423", label: "Liechtenstein +423" },
  { value: "LT", dialCode: "+370", label: "Lithuania +370" },
  { value: "LU", dialCode: "+352", label: "Luxembourg +352" },
  { value: "MO", dialCode: "+853", label: "Macau +853" },
  { value: "MG", dialCode: "+261", label: "Madagascar +261" },
  { value: "MW", dialCode: "+265", label: "Malawi +265" },
  { value: "MY", dialCode: "+60", label: "Malaysia +60" },
  { value: "MV", dialCode: "+960", label: "Maldives +960" },
  { value: "ML", dialCode: "+223", label: "Mali +223" },
  { value: "MT", dialCode: "+356", label: "Malta +356" },
  { value: "MH", dialCode: "+692", label: "Marshall Islands +692" },
  { value: "MQ", dialCode: "+596", label: "Martinique +596" },
  { value: "MR", dialCode: "+222", label: "Mauritania +222" },
  { value: "MU", dialCode: "+230", label: "Mauritius +230" },
  { value: "YT", dialCode: "+262", label: "Mayotte +262" },
  { value: "MX", dialCode: "+52", label: "Mexico +52" },
  { value: "FM", dialCode: "+691", label: "Micronesia +691" },
  { value: "MD", dialCode: "+373", label: "Moldova +373" },
  { value: "MC", dialCode: "+377", label: "Monaco +377" },
  { value: "MN", dialCode: "+976", label: "Mongolia +976" },
  { value: "ME", dialCode: "+382", label: "Montenegro +382" },
  { value: "MS", dialCode: "+1", label: "Montserrat +1" },
  { value: "MA", dialCode: "+212", label: "Morocco +212" },
  { value: "MZ", dialCode: "+258", label: "Mozambique +258" },
  { value: "MM", dialCode: "+95", label: "Myanmar +95" },
  { value: "NA", dialCode: "+264", label: "Namibia +264" },
  { value: "NR", dialCode: "+674", label: "Nauru +674" },
  { value: "NP", dialCode: "+977", label: "Nepal +977" },
  { value: "NL", dialCode: "+31", label: "Netherlands +31" },
  { value: "NC", dialCode: "+687", label: "New Caledonia +687" },
  { value: "NZ", dialCode: "+64", label: "New Zealand +64" },
  { value: "NI", dialCode: "+505", label: "Nicaragua +505" },
  { value: "NE", dialCode: "+227", label: "Niger +227" },
  { value: "NG", dialCode: "+234", label: "Nigeria +234" },
  { value: "NU", dialCode: "+683", label: "Niue +683" },
  { value: "NF", dialCode: "+672", label: "Norfolk Island +672" },
  { value: "KP", dialCode: "+850", label: "North Korea +850" },
  { value: "MK", dialCode: "+389", label: "North Macedonia +389" },
  { value: "MP", dialCode: "+1", label: "Northern Mariana Islands +1" },
  { value: "NO", dialCode: "+47", label: "Norway +47" },
  { value: "OM", dialCode: "+968", label: "Oman +968" },
  { value: "PK", dialCode: "+92", label: "Pakistan +92" },
  { value: "PW", dialCode: "+680", label: "Palau +680" },
  { value: "PS", dialCode: "+970", label: "Palestine +970" },
  { value: "PA", dialCode: "+507", label: "Panama +507" },
  { value: "PG", dialCode: "+675", label: "Papua New Guinea +675" },
  { value: "PY", dialCode: "+595", label: "Paraguay +595" },
  { value: "PE", dialCode: "+51", label: "Peru +51" },
  { value: "PH", dialCode: "+63", label: "Philippines +63" },
  { value: "PN", dialCode: "+64", label: "Pitcairn Islands +64" },
  { value: "PL", dialCode: "+48", label: "Poland +48" },
  { value: "PT", dialCode: "+351", label: "Portugal +351" },
  { value: "PR", dialCode: "+1", label: "Puerto Rico +1" },
  { value: "QA", dialCode: "+974", label: "Qatar +974" },
  { value: "RE", dialCode: "+262", label: "Reunion +262" },
  { value: "RO", dialCode: "+40", label: "Romania +40" },
  { value: "RU", dialCode: "+7", label: "Russia +7" },
  { value: "RW", dialCode: "+250", label: "Rwanda +250" },
  { value: "BL", dialCode: "+590", label: "Saint Barthelemy +590" },
  { value: "SH", dialCode: "+290", label: "Saint Helena +290" },
  { value: "KN", dialCode: "+1", label: "Saint Kitts and Nevis +1" },
  { value: "LC", dialCode: "+1", label: "Saint Lucia +1" },
  { value: "MF", dialCode: "+590", label: "Saint Martin +590" },
  { value: "PM", dialCode: "+508", label: "Saint Pierre and Miquelon +508" },
  { value: "VC", dialCode: "+1", label: "Saint Vincent and the Grenadines +1" },
  { value: "WS", dialCode: "+685", label: "Samoa +685" },
  { value: "SM", dialCode: "+378", label: "San Marino +378" },
  { value: "ST", dialCode: "+239", label: "Sao Tome and Principe +239" },
  { value: "SA", dialCode: "+966", label: "Saudi Arabia +966" },
  { value: "SN", dialCode: "+221", label: "Senegal +221" },
  { value: "RS", dialCode: "+381", label: "Serbia +381" },
  { value: "SC", dialCode: "+248", label: "Seychelles +248" },
  { value: "SL", dialCode: "+232", label: "Sierra Leone +232" },
  { value: "SG", dialCode: "+65", label: "Singapore +65" },
  { value: "SX", dialCode: "+1", label: "Sint Maarten +1" },
  { value: "SK", dialCode: "+421", label: "Slovakia +421" },
  { value: "SI", dialCode: "+386", label: "Slovenia +386" },
  { value: "SB", dialCode: "+677", label: "Solomon Islands +677" },
  { value: "SO", dialCode: "+252", label: "Somalia +252" },
  { value: "ZA", dialCode: "+27", label: "South Africa +27" },
  { value: "GS", dialCode: "+500", label: "South Georgia and South Sandwich Islands +500" },
  { value: "SS", dialCode: "+211", label: "South Sudan +211" },
  { value: "ES", dialCode: "+34", label: "Spain +34" },
  { value: "LK", dialCode: "+94", label: "Sri Lanka +94" },
  { value: "SD", dialCode: "+249", label: "Sudan +249" },
  { value: "SR", dialCode: "+597", label: "Suriname +597" },
  { value: "SJ", dialCode: "+47", label: "Svalbard and Jan Mayen +47" },
  { value: "SE", dialCode: "+46", label: "Sweden +46" },
  { value: "CH", dialCode: "+41", label: "Switzerland +41" },
  { value: "SY", dialCode: "+963", label: "Syria +963" },
  { value: "TJ", dialCode: "+992", label: "Tajikistan +992" },
  { value: "TZ", dialCode: "+255", label: "Tanzania +255" },
  { value: "TH", dialCode: "+66", label: "Thailand +66" },
  { value: "TL", dialCode: "+670", label: "Timor-Leste +670" },
  { value: "TG", dialCode: "+228", label: "Togo +228" },
  { value: "TK", dialCode: "+690", label: "Tokelau +690" },
  { value: "TO", dialCode: "+676", label: "Tonga +676" },
  { value: "TT", dialCode: "+1", label: "Trinidad and Tobago +1" },
  { value: "TN", dialCode: "+216", label: "Tunisia +216" },
  { value: "TR", dialCode: "+90", label: "Turkiye +90" },
  { value: "TM", dialCode: "+993", label: "Turkmenistan +993" },
  { value: "TC", dialCode: "+1", label: "Turks and Caicos Islands +1" },
  { value: "TV", dialCode: "+688", label: "Tuvalu +688" },
  { value: "UG", dialCode: "+256", label: "Uganda +256" },
  { value: "UA", dialCode: "+380", label: "Ukraine +380" },
  { value: "AE", dialCode: "+971", label: "United Arab Emirates +971" },
  { value: "GB", dialCode: "+44", label: "United Kingdom +44" },
  { value: "UY", dialCode: "+598", label: "Uruguay +598" },
  { value: "UZ", dialCode: "+998", label: "Uzbekistan +998" },
  { value: "VU", dialCode: "+678", label: "Vanuatu +678" },
  { value: "VA", dialCode: "+39", label: "Vatican City +39" },
  { value: "VE", dialCode: "+58", label: "Venezuela +58" },
  { value: "VN", dialCode: "+84", label: "Vietnam +84" },
  { value: "VG", dialCode: "+1", label: "British Virgin Islands +1" },
  { value: "VI", dialCode: "+1", label: "US Virgin Islands +1" },
  { value: "WF", dialCode: "+681", label: "Wallis and Futuna +681" },
  { value: "EH", dialCode: "+212", label: "Western Sahara +212" },
  { value: "YE", dialCode: "+967", label: "Yemen +967" },
  { value: "ZM", dialCode: "+260", label: "Zambia +260" },
  { value: "ZW", dialCode: "+263", label: "Zimbabwe +263" },
];

function buildPhoneValue(form) {
  const phone = String(form.phone || "").trim();
  if (!phone) return "";
  if (phone.startsWith("+")) return phone;
  const selectedCountry = phoneCountryOptions.find((option) => option.value === form.phone_country_code);
  return `${selectedCountry?.dialCode || "+81"} ${phone}`;
}

export default function RetailMemberAuthPanel({ onMemberChange, compact = false, paymentPageToken = "", myPage = false, language = "" }) {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState(() => ({
    email: "",
    password: "",
    confirm_password: "",
    full_name: "",
    phone_country_code: "JP",
    phone: "",
    preferred_language: normalizeMemberEmailLanguage(language || localStorage.getItem("public_booking_lang")),
    code: "",
    new_password: "",
  }));
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentMember, setCurrentMember] = useState(null);
  const [accountOpen, setAccountOpen] = useState(false);

  const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  useEffect(() => {
    if (!language) return;
    setForm((prev) => ({ ...prev, preferred_language: normalizeMemberEmailLanguage(language) }));
  }, [language]);

  const handleAuthResponse = (data, successMessage) => {
    if (data?.retail_member_token) {
      localStorage.setItem(retailTokenKey, data.retail_member_token);
    }
    if (data?.member) {
      setCurrentMember(data.member);
      setAccountOpen(true);
    }
    if (data?.member && onMemberChange) {
      onMemberChange(data.member, data.retail_member_token);
    }
    if (successMessage) {
      setMessage(successMessage);
    }
  };

  const memberDisplayName = (currentMember?.full_name || currentMember?.email || "").trim();

  const submitLogin = async () => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(`${API}/public-booking/member/login`, {
        email: form.email,
        password: form.password,
        payment_page_token: paymentPageToken || undefined,
      });
      const memberName = response.data?.member?.full_name || response.data?.member?.email || form.email;
      handleAuthResponse(response.data, `Welcome ${memberName}. You are signed in.`);
    } catch (error) {
      setMessage(error.response?.data?.detail || "Unable to sign in.");
    } finally {
      setLoading(false);
    }
  };

  const submitRegister = async () => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(`${API}/public-booking/member/register`, {
        email: form.email,
        password: form.password,
        confirm_password: form.confirm_password,
        full_name: form.full_name,
        phone: buildPhoneValue(form),
        preferred_language: form.preferred_language,
        payment_page_token: paymentPageToken || undefined,
      });
      handleAuthResponse(response.data, "Thank you for signing up. You are now automatically signed in.");
    } catch (error) {
      setMessage(error.response?.data?.detail || "Unable to create account.");
    } finally {
      setLoading(false);
    }
  };

  const requestReset = async () => {
    setLoading(true);
    setMessage("");
    try {
      await axios.post(`${API}/public-booking/member/password-reset/request`, { email: form.email });
      setMode("resetConfirm");
      setMessage("A 6-digit reset code has been sent if this email is registered.");
    } catch (error) {
      setMessage(error.response?.data?.detail || "Unable to send reset code.");
    } finally {
      setLoading(false);
    }
  };

  const confirmReset = async () => {
    setLoading(true);
    setMessage("");
    try {
      await axios.post(`${API}/public-booking/member/password-reset/confirm`, {
        email: form.email,
        code: form.code,
        new_password: form.new_password,
        confirm_password: form.confirm_password,
      });
      setMode("login");
      setMessage("Password updated. Please sign in.");
    } catch (error) {
      setMessage(error.response?.data?.detail || "Unable to reset password.");
    } finally {
      setLoading(false);
    }
  };

  const submit = () => {
    if (mode === "register") return submitRegister();
    if (mode === "reset") return requestReset();
    if (mode === "resetConfirm") return confirmReset();
    return submitLogin();
  };

  const modeHeading = mode === "register"
    ? "Create your member account"
    : mode === "reset" || mode === "resetConfirm"
      ? "Recover your member account"
      : "Welcome back";
  const modeDescription = mode === "register"
    ? "Save every reservation, receipt and reward in one private account."
    : mode === "reset" || mode === "resetConfirm"
      ? "We will help you return securely to your journeys and rewards."
      : "Sign in to manage your journeys, payments, receipts and rewards.";
  const fieldShellClass = myPage
    ? "flex min-h-[52px] w-full min-w-0 max-w-full items-center gap-3 rounded-[16px] border border-white/10 bg-white/[0.055] px-4 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.025)] transition focus-within:border-[#d8b769]/65 focus-within:bg-[#d8b769]/[0.055] focus-within:shadow-[0_0_0_3px_rgba(216,183,105,0.08)]"
    : "flex w-full min-w-0 max-w-full items-center gap-2 rounded-2xl border border-white/10 bg-white px-3 py-3 text-black";
  const standaloneInputClass = myPage
    ? "min-h-[52px] w-full min-w-0 max-w-full rounded-[16px] border border-white/10 bg-white/[0.055] px-4 text-sm text-white outline-none transition placeholder:text-white/30 focus:border-[#d8b769]/65 focus:bg-[#d8b769]/[0.055] focus:shadow-[0_0_0_3px_rgba(216,183,105,0.08)]"
    : "w-full min-w-0 max-w-full rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm text-black outline-none";

  return (
    <section
      className={myPage
        ? "relative overflow-hidden rounded-[34px] border border-[#d8b769]/30 bg-[linear-gradient(155deg,#15120c_0%,#090806_48%,#060606_100%)] p-6 shadow-[0_38px_100px_rgba(0,0,0,0.52),inset_0_1px_0_rgba(255,255,255,0.04)] sm:p-8 lg:h-full lg:p-9"
        : `w-full min-w-0 max-w-full overflow-hidden rounded-[26px] border border-[#d8b769]/25 bg-[#0b0a08] ${compact ? "p-4" : "p-5"} shadow-xl shadow-black/25`
      }
      data-testid={myPage ? "premium-member-auth-panel" : undefined}
    >
      {myPage && (
        <>
          <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-[#d8b769]/10 blur-[75px]" aria-hidden="true" />
          <div className="pointer-events-none absolute inset-x-10 top-0 h-px bg-gradient-to-r from-transparent via-[#f1d58b]/65 to-transparent" aria-hidden="true" />
        </>
      )}
      {currentMember && (
        <button
          type="button"
          onClick={() => setAccountOpen((value) => !value)}
          className="mb-4 w-full rounded-3xl border border-emerald-300/25 bg-emerald-300/10 p-4 text-left text-emerald-50 transition hover:border-[#d8b769]/45 hover:bg-[#d8b769]/10"
          aria-expanded={accountOpen}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-200" />
              <div>
                <p className="text-sm font-semibold">Welcome {memberDisplayName}</p>
                <p className="mt-1 text-xs leading-5 text-emerald-50/75">Your member account is connected to this booking.</p>
              </div>
            </div>
            <ChevronDown className={`mt-1 h-4 w-4 shrink-0 transition ${accountOpen ? "rotate-180" : ""}`} />
          </div>
          {accountOpen && (
            <div className="mt-3 grid gap-2 rounded-2xl bg-black/25 p-3 text-xs leading-5 text-white/70">
              <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
                <span className="text-white/40">Email</span>
                <span className="font-semibold text-white">{currentMember.email}</span>
              </div>
              {currentMember.full_name && (
                <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
                  <span className="text-white/40">Name</span>
                  <span className="font-semibold text-white">{currentMember.full_name}</span>
                </div>
              )}
              <p className="border-t border-white/10 pt-2">You can earn 3% to 5% points on completed rides and use member credit or points for future bookings.</p>
              <a href="/book/mypage" className="inline-flex items-center justify-center rounded-2xl border border-[#d8b769]/30 bg-[#d8b769]/10 px-3 py-2 text-xs font-bold text-[#f3d98b] transition hover:bg-[#d8b769] hover:text-black">
                Open My Page
              </a>
            </div>
          )}
        </button>
      )}

      <div className={`relative flex items-start ${myPage ? "gap-4" : "gap-3"}`}>
        <div className={`flex shrink-0 items-center justify-center bg-[#d8b769] text-black shadow-[0_12px_30px_rgba(216,183,105,0.18)] ${myPage ? "h-12 w-12 rounded-[17px]" : "h-10 w-10 rounded-2xl"}`}>
          {mode === "register" ? <UserPlus className="h-5 w-5" /> : <LockKeyhole className="h-5 w-5" />}
        </div>
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-[#d8b769]">Member Booking</p>
          <h2 className={`${myPage ? "mt-2 font-serif text-[29px] font-normal leading-tight text-[#f6f1e6]" : "mt-1 text-sm font-semibold text-white"}`}>{modeHeading}</h2>
          <p className={`${myPage ? "mt-2 text-xs leading-6 text-white/52" : "mt-1 text-xs leading-5 text-white/55"}`}>{modeDescription}</p>
        </div>
      </div>

      <div className={`${myPage ? "relative mt-7 rounded-[17px] border border-white/[0.065] bg-black/30 p-1.5" : "mt-4 rounded-2xl bg-white/[0.04] p-1"} grid grid-cols-3 gap-1.5 text-[11px] font-semibold`}>
        {[
          ["login", "Login"],
          ["register", "Sign up"],
          ["reset", "Reset Password"],
        ].map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setMode(key)}
            className={`rounded-[12px] px-2 py-2.5 transition ${mode === key || (key === "reset" && mode === "resetConfirm") ? "bg-[linear-gradient(135deg,#eed083,#cda653)] text-[#171109] shadow-[0_8px_22px_rgba(216,183,105,0.16)]" : "text-white/48 hover:bg-white/[0.04] hover:text-white"}`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className={`${myPage ? "relative mt-6 gap-3.5" : "mt-4 gap-3"} grid`}>
        <label className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/38">Email address</label>
        <div className={fieldShellClass}>
          <Mail className={`h-4 w-4 shrink-0 ${myPage ? "text-[#d8b769]/72" : "text-black/40"}`} />
          <input className={`w-full bg-transparent text-sm outline-none ${myPage ? "text-white placeholder:text-white/30" : ""}`} type="email" value={form.email} onChange={(event) => update("email", event.target.value)} placeholder="name@example.com" />
        </div>

        {mode === "register" && (
          <>
            <input className={standaloneInputClass} value={form.full_name} onChange={(event) => update("full_name", event.target.value)} placeholder="Full name" />
            <div className="grid gap-2 sm:grid-cols-[190px_1fr]">
              <select
                className={`${standaloneInputClass} ${myPage ? "[color-scheme:dark]" : ""}`}
                value={form.phone_country_code}
                onChange={(event) => update("phone_country_code", event.target.value)}
                aria-label="Phone country code"
              >
                {phoneCountryOptions.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
              <input
                className={standaloneInputClass}
                inputMode="tel"
                value={form.phone}
                onChange={(event) => update("phone", event.target.value)}
                placeholder="Phone number"
              />
            </div>
            <label className="grid gap-2">
              <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/38">Email language</span>
              <select
                className={`${standaloneInputClass} ${myPage ? "[color-scheme:dark]" : ""}`}
                value={form.preferred_language}
                onChange={(event) => update("preferred_language", event.target.value)}
                aria-label="Email language"
              >
                {memberEmailLanguageOptions.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
              <span className="text-[11px] leading-5 text-white/42">Welcome, booking, payment and account emails will use this language.</span>
            </label>
          </>
        )}

        {(mode === "login" || mode === "register") && (
          <div className={fieldShellClass}>
            <LockKeyhole className={`h-4 w-4 shrink-0 ${myPage ? "text-[#d8b769]/72" : "text-black/40"}`} />
            <input className={`w-full bg-transparent text-sm outline-none ${myPage ? "text-white placeholder:text-white/30" : ""}`} type="password" value={form.password} onChange={(event) => update("password", event.target.value)} placeholder="Password" />
          </div>
        )}

        {mode === "register" && (
          <input className={standaloneInputClass} type="password" value={form.confirm_password} onChange={(event) => update("confirm_password", event.target.value)} placeholder="Confirm password" />
        )}

        {mode === "resetConfirm" && (
          <>
            <input className={standaloneInputClass} inputMode="numeric" value={form.code} onChange={(event) => update("code", event.target.value)} placeholder="6-digit code" />
            <input className={standaloneInputClass} type="password" value={form.new_password} onChange={(event) => update("new_password", event.target.value)} placeholder="New password" />
            <input className={standaloneInputClass} type="password" value={form.confirm_password} onChange={(event) => update("confirm_password", event.target.value)} placeholder="Confirm password" />
          </>
        )}
      </div>

      {message && <p className="relative mt-3 rounded-xl border border-[#d8b769]/18 bg-[#d8b769]/[0.06] px-3 py-2.5 text-xs leading-5 text-[#f3d98b]">{message}</p>}

      <button
        type="button"
        onClick={submit}
        disabled={loading}
        className={`${myPage ? "relative mt-5 min-h-[54px] rounded-[16px] bg-[linear-gradient(135deg,#efd082_0%,#d3ab57_58%,#bd9144_100%)] shadow-[0_18px_40px_rgba(216,183,105,0.16)] hover:-translate-y-0.5 hover:shadow-[0_22px_46px_rgba(216,183,105,0.23)]" : "mt-4 rounded-2xl bg-[#d8b769] py-3 hover:brightness-110"} inline-flex w-full items-center justify-center px-4 text-sm font-bold text-[#151009] transition disabled:opacity-50`}
      >
        {loading ? "Please wait..." : mode === "register" ? "Sign up" : mode === "reset" ? "Send reset code" : mode === "resetConfirm" ? "Set new password" : "Sign in"}
      </button>
      {myPage && (
        <p className="relative mt-4 flex items-center justify-center gap-2 text-[10px] leading-5 text-white/32">
          <ShieldCheck className="h-3.5 w-3.5 text-[#d8b769]/65" />
          Secure member access · Your details remain private
        </p>
      )}
    </section>
  );
}

export function TravelAgencyAuthPanel({ onTravelAgencyChange, compact = false }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentAgency, setCurrentAgency] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(travelAgencyUserKey) || "null");
    } catch {
      return null;
    }
  });

  const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const submitTravelAgencyLogin = async () => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email: form.email,
        password: form.password,
      });
      const token = response.data?.access_token || "";
      const user = response.data?.user || null;
      if (token) {
        localStorage.setItem("token", token);
      }
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        setCurrentAgency(user);
      }
      if (onTravelAgencyChange) {
        onTravelAgencyChange(user, token);
      }
      setMessage("Travel agency account is signed in for this payment.");
    } catch (error) {
      setMessage(error.response?.data?.detail || "Unable to sign in with travel agency account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={`rounded-[26px] border border-[#d8b769]/25 bg-[#0b0a08] ${compact ? "p-4" : "p-5"} shadow-xl shadow-black/25`}>
      {currentAgency && (
        <div className="mb-4 rounded-3xl border border-emerald-300/25 bg-emerald-300/10 p-4 text-emerald-50">
          <div className="flex items-start gap-3">
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-200" />
            <div>
              <p className="text-sm font-semibold">Signed in as {currentAgency.name || currentAgency.email}</p>
              <p className="mt-1 text-xs leading-5 text-emerald-50/75">Travel agency account is signed in for this payment.</p>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#d8b769] text-black">
          <LockKeyhole className="h-5 w-5" />
        </div>
        <div>
          <p className="text-sm font-semibold text-white">Travel Agency Login</p>
          <p className="mt-1 text-xs leading-5 text-white/55">Use your approved travel agency reservation account, then continue payment securely by Square.</p>
        </div>
      </div>

      <div className="mt-4 grid gap-3">
        <label className="text-xs font-semibold uppercase tracking-[0.18em] text-white/45">Email or phone</label>
        <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white px-3 py-3 text-black">
          <Mail className="h-4 w-4 text-black/40" />
          <input className="w-full bg-transparent text-sm outline-none" type="text" value={form.email} onChange={(event) => update("email", event.target.value)} placeholder="agency@example.com" />
        </div>
        <input className="rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm text-black outline-none" type="password" value={form.password} onChange={(event) => update("password", event.target.value)} placeholder="Password" />
      </div>

      {message && <p className="mt-3 text-xs leading-5 text-[#f3d98b]">{message}</p>}

      <button
        type="button"
        onClick={submitTravelAgencyLogin}
        disabled={loading}
        className="mt-4 inline-flex w-full items-center justify-center rounded-2xl bg-[#d8b769] px-4 py-3 text-sm font-bold text-black transition hover:brightness-110 disabled:opacity-50"
      >
        {loading ? "Please wait..." : "Sign in travel agency account"}
      </button>
    </section>
  );
}
